// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebDeleteSavedSearchesRequest,
  TWebDeleteSavedSearchesModel,
  IMappers,
  TWebDeleteSavedSearchesResponse,
  TWebDeleteSavedSearchesResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebDeleteSavedSearchesModel(
  parameters: TWebDeleteSavedSearchesRequest,
): TWebDeleteSavedSearchesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'saved-searches',
    pathApi: '/v1/web/delete-saved-searches/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebDeleteSavedSearchesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebDeleteSavedSearchesRequest;
}

export async function fetchWebDeleteSavedSearches<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebDeleteSavedSearchesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebDeleteSavedSearchesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebDeleteSavedSearchesModel(parameters),
    config,
  )) as FetchResponse<TWebDeleteSavedSearchesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TWebDeleteSavedSearchesResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebDeleteSavedSearchesResponse>;
}
